import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "./Payment.scss"

const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#1A1A1A",
        fontSize: "16px",
        fontFamily: "Inter, sans-serif",
        iconColor: "#C32340",
        "::placeholder": {
          color: "#A3A3A3",
        },
        backgroundColor: "#FAFAFA",
        padding: "12px 16px",
      },
      invalid: {
        color: "#C32340",
      },
    },
    hidePostalCode: true,
  };
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);
const CheckoutForm: React.FC = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const res = await fetch("http://localhost:5000/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: 1000, currency: "usd" }),
    });

    const { clientSecret } = await res.json();

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: { card: elements.getElement(CardElement)! },
    });

    if (result.error) {
      console.error(result.error.message);
    } else {
      console.log("Payment successful:", result.paymentIntent);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="stripe-checkout">
    <div className="stripe-card-input">
      <CardElement options={CARD_ELEMENT_OPTIONS} />
    </div>
    <button type="submit" className="stripe-pay-btn">
      Pay Now
    </button>
  </form>
  );
};

const StripePayment: React.FC = () => (
  <Elements stripe={stripePromise}>
    <CheckoutForm />
  </Elements>
);

export default StripePayment;
